import { Component } from '@angular/core';
import {AuthService} from "../../../services/auth.service";

@Component({
  selector: 'app-profile-my-plan',
  templateUrl: './profile-my-plan.component.html',
  styleUrls: ['./profile-my-plan.component.css',
    '../../layouts/profile-subscription-card/profile-subscription-card.component.css']
})
export class ProfileMyPlanComponent {

  protected readonly currentUserId: string | null;

  protected selectedIndex: 1 | 2 = 1;

  // fixme: when there are real subscriptions remove this data.
  protected subscriptions: object[] = [
    {}, {}, {}
  ]
  protected subscriptionsCount: number = this.subscriptions.length;

  protected isMonthlySelected: boolean = true;

  constructor(
    private readonly authService: AuthService
  ) {
    this.currentUserId = this.authService.getCurrentUserId();
  }

  get isMyPlanSelected() {
    return this.selectedIndex == 1;
  }

  protected getClassesBySubscriptionsCount(): string {
    switch (this.subscriptionsCount) {
      case 1:
        return 'col-md-12 col-lg-12'
      case 2:
        return 'col-md-6 col-lg-6'
      case 3:
        return 'col-md-4 col-lg-4'
      default:
        return 'col-md-6 col-lg-6 d-flex flex-wrap'
    }
  }
}
